import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { API } from '../App';

const NewsCard = () => {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const res = await axios.get(`${API}/news/daily`);
        if (mounted) setArticles((res.data?.articles || []).slice(0, 3));
      } catch {
        if (mounted) setArticles([]);
      } finally {
        if (mounted) setLoading(false);
      }
    })();
    return () => { mounted = false; };
  }, []);

  return (
    <div className="news-card-widget" data-testid="news-dashboard-card">
      <div className="news-card-widget-header">
        <h3>
          <i className="fa-solid fa-newspaper" style={{ marginRight: 8, color: '#2c5364' }}></i>
          Today's Alzheimer's & Dementia News
        </h3>
        <Link to="/news" className="news-card-widget-view-all" data-testid="news-card-view-all">
          View all <i className="fa-solid fa-arrow-right"></i>
        </Link>
      </div>

      {loading && <p className="news-card-widget-loading">Loading headlines…</p>}

      {!loading && articles.length === 0 && (
        <p className="news-card-widget-empty">No headlines available right now.</p>
      )}

      {!loading && articles.length > 0 && (
        <ul className="news-card-widget-list">
          {articles.map((a, i) => (
            <li key={a.link || i} data-testid={`news-headline-${i}`}>
              <a href={a.link} target="_blank" rel="noopener noreferrer">
                <span className="news-card-widget-title">{a.title}</span>
                <span className="news-card-widget-source">{a.source}</span>
              </a>
              {a.ai_takeaway && (
                <p className="news-card-widget-takeaway">
                  <i className="fa-solid fa-wand-magic-sparkles"></i> {a.ai_takeaway}
                </p>
              )}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default NewsCard;
